module.exports = __webpack_public_path__ + "static/img/Adaptability.41d242d3.png";